bcl.s.loading = {
  props: {
    dynamicClass: ".bhg-loading.dynamicLoading",
    stylesheetHref: "/etc.clientlibs/barcelo/clientlibs/clientlib-loadings.css",
    defaultLoading: null,
    loader: null,
  },

  isMobileViewport() {
    return typeof window.matchMedia === "function" && window.matchMedia("(max-width: 768px)").matches;
  },

  loadStyles() {
    bcl.u.loadStyleSheet(bcl.s.loading.props.stylesheetHref, bcl.s.loading.props.dynamicClass);
  },

  init(baseDom) {
    const baseFind = baseDom || document;
    const authorURLS = /localhost|author-barcelo-dev-65.adobecqms.net|author-barcelo-stage-65.adobecqms.net|author-barcelo-prod-65.adobecqms.net/;
    const loadingDataset = baseFind.body.dataset.loading;

    if (!loadingDataset) {
      return;
    }

    const loadingURL = authorURLS.test(location.hostname) ? `${loadingDataset}?wcmmode=disabled` : loadingDataset;

    bcl.s.loading.props.defaultLoading = loadingURL;

    bcl.s.loading.loadStyles();

    if (bcl.s.loading.isMobileViewport()) {
      return;
    }

    if (bcl.s.loading.props.defaultLoading) {
      bcl.ajax.getRequest(null, bcl.s.loading.props.defaultLoading, bcl.s.loading.saveLoading, null, null, null, false);
    }
  },

  loadNewLoader(url) {
    if (!url) {
      console.error("No URL provided for loading new loader");
      return;
    }

    bcl.s.loading.loadStyles();
    bcl.ajax.getRequest(bcl.s.loading.props.loader, url);
  },

  saveLoading(request) {
    if (!request || !request.response) {
      console.error("Invalid request or response in saveLoading");
      return;
    }

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = request.response;

    const realLoader = tempDiv.querySelector(bcl.s.loading.props.dynamicClass);

    if (!realLoader) {
      console.error(`Could not find '${bcl.s.loading.props.dynamicClass}' in the received HTML`);
      return;
    }

    bcl.s.loading.props.loader = realLoader.cloneNode(true);
  },
};

bcl.preInit.push(bcl.s.loading.init);
